import FooterSwitchComponent from '../site_interfaces/footers/footer_switch'


class AiFooter extends FooterSwitchComponent {

}

export default AiFooter;



// WEBPACK FOOTER //
// ./src/layout/AiFooter.js